/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type appOnelogin_viewer$ref: FragmentReference;
declare export opaque type appOnelogin_viewer$fragmentType: appOnelogin_viewer$ref;
export type appOnelogin_viewer = {|
  +id: string,
  +company: ?{|
    +id: string,
    +oneloginEnabled: ?boolean,
    +oktaEnabled: ?boolean,
    +AADEnabled: ?boolean,
    +scimUsernamePassword: ?string,
    +oneloginClientId: ?string,
    +oneloginClientSecret: ?string,
    +oneloginUrl: ?string,
  |},
  +$refType: appOnelogin_viewer$ref,
|};
export type appOnelogin_viewer$data = appOnelogin_viewer;
export type appOnelogin_viewer$key = {
  +$data?: appOnelogin_viewer$data,
  +$fragmentRefs: appOnelogin_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appOnelogin_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "oneloginEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "oktaEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "AADEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "scimUsernamePassword",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "oneloginClientId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "oneloginClientSecret",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "oneloginUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
// prettier-ignore
(node/*: any*/).hash = '9ace58736daff2a3de7dd2c73c4e7a43';

module.exports = node;
